const ListHeader = [{
    name: 'plate',
    value: 'scooter.plate',
    sortable: true,
    width: 148,
}, {
    name: 'model',
    value: 'scooter.model',
    sortable: true,
    width: 83,
}, {
    name: 'city',
    value: 'scooter.city',
    sortable: true,
    width: 90,
}, {
    name: 'is_activate',
    value: 'scooter.service',
    sortable: true,
    width: 94,
}, {
    name: 'rental_state',
    value: 'scooter.rental_state',
    sortable: true,
    width: 85,
}, {
    name: 'soc',
    value: 'scooter.battery',
    sortable: true,
    width: 97,
}, {
    name: 'tracker_soc',
    value: 'scooter.tracker_soc',
    sortable: true,
    width: 96,
}, {
    name: 'satellites',
    value: 'scooter.satellites',
    sortable: true,
    width: 96,
}, {
    name: 'tracker_subtype_id',
    value: 'ticket.sub_type',
    sortable: true,
    width: 150,
}, {
    name: 'idle_time',
    value: 'scooter.idle',
    sortable: true,
    width: 120,
}, {
    name: 'last_connection_date',
    value: 'scooter.lct',
    sortable: true,
    width: 120,
}, {
    name: 'corporate_name',
    value: 'scooter.corporate',
    sortable: false,
    width: 120,
}];

export default  ListHeader;
